'use strict';

// require('babel-polyfill');
// global._regeneratorRuntime = require('regenerator-runtime/runtime');

// if (typeof Promise === 'undefined') {
//   // Rejection tracking prevents a common issue where React gets into an
//   // inconsistent state due to an error, but it gets swallowed by a Promise,
//   // and the user has no idea what causes React's erratic future behavior.
//   require('promise/lib/rejection-tracking').enable();
//   window.Promise = require('promise/lib/es6-extensions.js');
// }

// fetch() polyfill for making API calls.
// require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
// Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
var _asyncToGenerator = require("/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}
if (typeof EventSource === 'undefined') {
  require('event-source-polyfill/src/eventsource.min.js');
}
if (typeof ReadableStream === 'undefined') {
  (function () {
    var mozFetch = require('fetch-readablestream');
    var streams = require('web-streams-polyfill');
    var _require = require('fetch-readablestream/lib/xhr'),
      makeXhrTransport = _require.makeXhrTransport;
    var _require2 = require('@mattiasbuelens/web-streams-adapter'),
      createReadableStreamWrapper = _require2.createReadableStreamWrapper;
    var toPolyfilledReadableStream = createReadableStreamWrapper(streams.ReadableStream);
    var defaultFactory = require('fetch-readablestream/lib/defaultTransportFactory').default;
    mozFetch.transportFactory = !supportsXhrResponseType('moz-chunked-arraybuffer') ? defaultFactory : function (transport) {
      return function () {
        return transport;
      };
    }(makeXhrTransport({
      responseType: 'moz-chunked-arraybuffer',
      responseParserFactory: function responseParserFactory() {
        return function (response) {
          return protectArrayBufferFromWhatwgRefImpl(new Uint8Array(response));
        };
      }
    }));
    window.fetch = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var res,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return mozFetch.apply(void 0, _args);
          case 1:
            res = _context.v;
            res.body = toPolyfilledReadableStream(res.body);
            res.bodyUsed = false;
            return _context.a(2, res);
        }
      }, _callee);
    }));
    var kIsFakeBuffer = Symbol.for('isFakeBuffer');

    // The Whatwg ReadableByteStream reference implementation[1] copies the
    // underlying ArrayBuffer for any TypedArray that passes through it and
    // redefines the original's byteLength to be 0, in order to mimic the
    // unfinished ArrayBuffer "transfer" spec [2].
    // 
    // This is problematic in node, where a number of APIs (like fs.ReadStream)
    // internally allocate and share ArrayBuffers between unrelated operations.
    // It's also problematic when using the reference implementation as a polyfill
    // in the browser, since it leads to the same bytes being copied at every link
    // in a bytestream pipeline.
    // 
    // They do this because there are some web-platform tests that check whether
    // byteLength has been set to zero to infer whether the buffer has been
    // "transferred". We don't need to care about these tests in production, and
    // we also wish to _not_ copy bytes as they pass through a stream, so this
    // function fakes out the reference implementation to work around both these
    // issues.
    // 
    // 1. https://github.com/whatwg/streams/blob/0ebe4b042e467d9876d80ae045de3843092ad797/reference-implementation/lib/helpers.js#L126
    // 2. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer/transfer

    function protectArrayBufferFromWhatwgRefImpl(value) {
      var real = value.buffer;
      if (!real[kIsFakeBuffer]) {
        var fake = Object.create(real);
        Object.defineProperty(fake, kIsFakeBuffer, {
          value: true
        });
        Object.defineProperty(fake, 'slice', {
          value: function value() {
            return real;
          }
        });
        Object.defineProperty(value, 'buffer', {
          value: fake
        });
      }
      return value;
    }
    function supportsXhrResponseType(type) {
      try {
        var tmp = new XMLHttpRequest();
        tmp.responseType = type;
        return tmp.responseType === type;
      } catch (e) {/* IE throws on setting responseType to an unsupported value */}
      return false;
    }
  })();
} else {
  // stub out pipeTo for FireFox v66+
  ReadableStream.prototype.pipeTo = ReadableStream.prototype.pipeTo || function () {};
}